import { render, staticRenderFns } from "./SchoolDegree.vue?vue&type=template&id=30cf4d54&scoped=true&"
import script from "./SchoolDegree.vue?vue&type=script&lang=js&"
export * from "./SchoolDegree.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDegree.vue?vue&type=style&index=0&id=30cf4d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf4d54",
  null
  
)

export default component.exports